/* DemoPool free tool: music pitch email generator. Templates only, runs in the browser.
   v2 (10.10.2026): shared tool frame UI, Pitch / Follow-up tabs, one Copy button, CTA strip follows the recipient. build() and checks() unchanged. */
(function () {
  'use strict';
  // Per audience: outlet label, fallback for {o}, personal opener, ask per tone, type-specific subject prefix.
  var A = {
    curator: { l: 'Playlist name', ph: 'Late Night Techno', o: 'your playlist',
      open: "I've had {o} on repeat, especially [a track you added recently].",
      ask: ['Would it fit {o}?', 'I think it could sit well on {o}. Would you give it a listen?', 'I would be grateful if you would consider it for {o}.'],
      s3: 'For {o}: {t} by {a}', pre: 1 },
    label: { l: 'Label name', ph: 'Anjunadeep', o: 'your label',
      open: 'Your recent release [release name] is exactly the lane I am working in.',
      ask: ['It is unsigned. Is it a fit for {o}?', "It's unsigned, and I think it fits what {o} puts out. Would you take a listen?", 'It is unsigned and I would like to submit it for release consideration on {o}.'],
      s3: 'Demo: {a} – {t} ({g}, unsigned)', pre: 0 },
    radio: { l: 'Show or station', ph: 'Night Shift on KEXP', o: 'your show',
      open: 'I caught your last show and loved [a track or moment from it].',
      ask: ['Could it get a spin on {o}?', "I'd love to hear it on {o}. A radio edit is ready if you need one.", 'I would like to submit it for airplay on {o}. A radio edit is available.'],
      s3: 'For airplay: {a} – {t} ({g})', pre: 1 },
    blog: { l: 'Blog or magazine', ph: 'Electronic Groove', o: 'you',
      open: 'Really enjoyed your piece on [artist or article].',
      ask: ['Open to a premiere?', 'Happy to give {o} the premiere before release day if it works for you.', 'I would like to offer {o} the premiere, or a review ahead of release.'],
      s3: 'Premiere offer: {a} – {t}{d}', pre: 1 },
    dj: { l: 'Their mix, show or label', ph: 'Essential Mix', o: 'your sets',
      open: 'Your set at [event or mix] has been a reference for me.',
      ask: ['Would it work in {o}?', "If it works in {o}, I'd love to hear what you think. The download is in the link.", 'I would value your feedback and support. The full track is available to download via the link.'],
      s3: 'Promo for {o}: {a} – {t} ({g})', pre: 1 },
    booking: { l: 'Agency name', ph: 'Mirror Agency', o: 'you',
      open: 'I see you work with [an artist on your roster], which is close to my world.',
      ask: ['Open to a chat about booking?', "I'm building my live calendar and would love to talk about working with {o}.", 'I would like to discuss booking or representation with {o}.'],
      s3: 'Booking: {a}, {g} live act', pre: 0 }
  };
  var TONES = ['short', 'friendly', 'formal'];
  // who you write to -> collection behind the CTA strip
  // [collection, old label, facts key of the list for the cart]
  var GO = { curator: ['playlist-curators', 'Find playlist curators', 'playlist-curators'], label: ['record-labels', 'Find record labels', 'record-labels'],
    radio: ['radio-stations', 'Find radio stations', 'radio-stations'], blog: ['music-blogs', 'Find music blogs', 'music-blogs'],
    dj: ['djs-producers', 'Find DJs', 'beatport-artists'], booking: ['booking-agents', 'Find booking agents', 'booking-agents'] };
  var $ = function (id) { return document.getElementById(id); };
  var form = $('pg-form');
  if (!form) return;
  var bodyEl = $('pg-body'), fuEl = $('pg-fu-body'), subjsEl = $('pg-subjs'), subjEl = $('pg-subj');
  var dirty = false, dirtyFu = false, subjects = [], chosen = 0, subjCustom = null, tab = 'email';

  function parseDate(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
    return m ? new Date(+m[1], m[2] - 1, +m[3]) : null;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function today() { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
  function fill(s, m) { return s.replace(/\{(\w)\}/g, function (_, k) { return m[k] == null ? '' : m[k]; }); }
  function words(s) { var w = s.trim().match(/\S+/g); return w ? w.length : 0; }
  function vals() {
    var f = new FormData(form), v = {};
    f.forEach(function (x, k) { v[k] = String(x).trim(); });
    return v;
  }

  // Pure generator: input values -> {subjects, body, followUp, meta}. Exposed for tests.
  function build(v, now) {
    var a = A[v.to] || A.curator, ti = Math.max(0, TONES.indexOf(v.tone));
    var art = v.artist || '[Artist]', tit = v.title || '[Track title]', g = v.genre || '';
    var o = v.outlet || a.o, rd = parseDate(v.date), now0 = now || today();
    var future = rd && rd > now0, dtxt = rd ? fmt(rd) : '';
    var m = { a: art, t: tit, g: g || 'new music', o: o, d: future ? ', out ' + dtxt : '' };
    var greet = ti === 2 ? (v.name ? 'Dear ' + v.name + ',' : 'Hello,') : (v.name ? 'Hi ' + v.name + ',' : 'Hi there,');
    var me = ti === 2 ? 'My name is ' + art + '. ' : "I'm " + art + '. ';
    var kind = (g ? g + ' ' : '') + 'track';
    var track = me + (rd ? (ti === 0 ? 'New ' : 'My new ') + kind + ' "' + tit + '"' + (future ? ' is out ' : ' came out ') + dtxt
      : (ti === 0 ? 'New ' + kind + ': "' + tit + '"' : 'My new ' + kind + ' is "' + tit + '"')) + '.';
    var lines = [greet, '', fill(a.open, m), '', track];
    var mid = [];
    if (v.hook) mid.push(v.hook.replace(/[.\s]+$/, '') + '.');
    if (v.comps) mid.push('For fans of ' + v.comps.replace(/[.\s]+$/, '').replace(/\s*[,&\/]\s*(?=[^,&\/]+$)/, ' and ') + '.');
    if (v.proof) { var pf = v.proof.replace(/[.\s]+$/, ''); mid.push((ti === 2 ? 'So far: ' + pf.charAt(0).toLowerCase() + pf.slice(1) : pf) + '.'); }
    if (mid.length) lines[4] += ' ' + mid.join(' ');
    lines.push('', (ti === 2 ? 'Listen here: ' : 'Listen: ') + (v.link || '[private link]'), '', fill(a.ask[ti], m), '',
      ['Thanks,', 'Thanks for listening,', 'Kind regards,'][ti], art);
    var body = lines.join('\n');

    var s1 = art + ' – "' + tit + '"' + (g ? ' (' + g + ')' : '') + (v.outlet ? ' for ' + v.outlet : '');
    var s2 = v.comps ? 'For fans of ' + v.comps + ': ' + art + ' – ' + tit
      : v.proof ? art + ' – ' + tit + ' (' + v.proof.split(/[,.;]/)[0].trim() + ')'
      : 'New ' + (g || 'music') + ': ' + art + ' – ' + tit + (future ? ', out ' + dtxt : '');
    var s3 = fill(a.s3, m);

    var fuDate = new Date(now0); fuDate.setDate(fuDate.getDate() + 7);
    var fu = [greet, '',
      (ti === 2 ? 'I wanted to follow up on my email about "' + tit + '" from last week.' : 'Quick follow-up on "' + tit + '" in case it got buried.') +
        (rd ? (rd > fuDate ? ' It comes out ' + dtxt + '.' : rd > now0 ? ' It is out ' + dtxt + '.' : '') : ''),
      '', v.link || '[private link]', '',
      ti === 2 ? 'If it is not right for ' + o + ', a short reply would help me plan. Thank you for your time.'
        : 'If it is not a fit for ' + o + ', a quick no is totally fine and helps me plan.',
      '', ['Thanks,', 'Thanks again,', 'Kind regards,'][ti], art].join('\n');

    return { subjects: [s1, s2, s3], body: body, followUp: fu, fuDate: fuDate, rd: rd, now: now0, pre: a.pre };
  }

  // Checklist on the current (possibly edited) text.
  function checks(v, body, r) {
    var urls = body.match(/https?:\/\/\S+/g) || [];
    var days = r.rd ? Math.round((r.rd - r.now) / 864e5) : null;
    return {
      name: { ok: !!v.name, tip: 'Add their first name' },
      line: { ok: !/\[[^\]]+\]/.test(body.replace(/\[(private link|Artist|Track title)\]/g, '')), tip: 'Replace the [brackets] with a real detail' },
      link: { ok: urls.length === 1, tip: urls.length ? 'Keep it to one link' : 'Add your link' },
      words: { ok: words(body) <= 120, tip: 'Cut it to 120 words' },
      date: { ok: !r.pre || (days !== null && days >= 7), na: !r.pre,
        tip: days === null ? 'Add the release date' : days < 0 ? 'Already out: pitch as a recent release' : 'Less than 7 days to release' }
    };
  }

  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var last;
  var ORDER = ['link', 'line', 'words', 'name', 'date'];
  function subject() { var x = subjCustom != null ? subjCustom : (subjects[chosen] || ''); return tab === 'fu' ? 'Re: ' + x : x; }

  function render() {
    var v = vals(), r = build(v);
    last = r;
    var a = A[v.to] || A.curator;
    $('pg-outlet-l').textContent = a.l;
    $('pg-outlet').placeholder = a.ph;
    subjects = r.subjects;
    if (chosen > 2) chosen = 0;
    subjsEl.innerHTML = subjects.map(function (s, i) {
      return '<button class="pg3__alt" type="button" data-i="' + i + '" aria-pressed="' + (i === chosen && subjCustom == null) + '" aria-label="Subject option ' + (i + 1) + '" title="' + esc(s) + '">' + (i + 1) + '</button>';
    }).join('');
    if (!dirty) bodyEl.value = r.body;
    if (!dirtyFu) fuEl.value = r.followUp;
    $('pg-fu-date').textContent = '· ' + fmt(r.fuDate);
    var go = GO[v.to] || GO.curator;
    $('pg-go').href = '/collections/' + go[0];
    // 20.10.2026: the strip adds the recipient's list in the typed genre to the cart (assets/dp-tool-buy.js on [data-buy])
    var wrap = $('pg-buy');
    if (wrap) { wrap.setAttribute('data-buy', go[2]); wrap.setAttribute('data-buy-gtext', v.genre || ''); }
    else $('pg-go-t').textContent = go[1];
    refresh();
  }

  function refresh() {
    var v = vals(), fu = tab === 'fu', body = fu ? fuEl.value : bodyEl.value, n = words(body);
    if (document.activeElement !== subjEl) subjEl.value = subject();
    var wc = $('pg-wc'), tip = $('pg-tip');
    wc.textContent = n + ' words';
    wc.classList.toggle('is-over', n > 120);
    if (fu) { tip.textContent = 'Send on ' + fmt(last.fuDate) + ', same thread'; tip.className = 'pg3__tip'; }
    else {
      var c = checks(v, body, last), miss = ORDER.filter(function (k) { return !c[k].ok && !c[k].na; })[0];
      tip.textContent = miss ? c[miss].tip : 'Ready to send';
      tip.className = 'pg3__tip ' + (miss ? 'is-miss' : 'is-ok');
    }
    var su = subjEl.value;
    $('pg-gmail').href = 'https://mail.google.com/mail/?view=cm&fs=1&su=' + encodeURIComponent(su) + '&body=' + encodeURIComponent(body);
  }

  function setTab(t) {
    tab = t;
    document.querySelectorAll('.pg3__tab').forEach(function (b) {
      var on = b.getAttribute('data-tab') === t;
      b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
      if (on) $('pg-panel').setAttribute('aria-labelledby', b.id);
    });
    bodyEl.hidden = t === 'fu'; fuEl.hidden = t !== 'fu';
    subjsEl.hidden = t === 'fu';
    $('pg-copy').textContent = t === 'fu' ? 'Copy follow-up' : 'Copy email';
    $('pg-body').previousElementSibling.textContent = t === 'fu' ? 'Follow-up text' : 'Email text';
    refresh();
  }

  function toast(msg) {
    var t = $('pg-toast'), b = $('pg-copy'); t.textContent = msg;
    b.textContent = msg; b.classList.add('is-done');
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.textContent = ''; b.classList.remove('is-done'); b.textContent = tab === 'fu' ? 'Copy follow-up' : 'Copy email'; }, 1800);
  }
  function copy(text, label) {
    var done = function () { toast(label + ' copied'); };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, fallback);
    else fallback();
    function fallback() {
      var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;opacity:0'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) { toast('Select and copy'); }
      ta.remove();
    }
  }

  form.addEventListener('input', render);
  form.addEventListener('change', render);
  form.addEventListener('submit', function (e) { e.preventDefault(); });
  subjsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (!b) return; chosen = +b.getAttribute('data-i'); subjCustom = null; subjEl.value = subject(); render(); });
  subjEl.addEventListener('input', function () { var x = subjEl.value; subjCustom = tab === 'fu' ? x.replace(/^Re:\s*/, '') : x; subjsEl.querySelectorAll('[data-i]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); refresh(); });
  bodyEl.addEventListener('input', function () { dirty = bodyEl.value !== last.body; refresh(); });
  fuEl.addEventListener('input', function () { dirtyFu = true; refresh(); });
  var tabs = document.querySelector('.pg3__tl');
  tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b) setTab(b.getAttribute('data-tab')); });
  tabs.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var t = tab === 'fu' ? 'email' : 'fu'; setTab(t); $(t === 'fu' ? 'pg-tab-fu' : 'pg-tab-email').focus(); e.preventDefault();
  });
  $('pg-copy').addEventListener('click', function () {
    var fu = tab === 'fu';
    copy(fu ? fuEl.value : bodyEl.value, fu ? 'Follow-up' : 'Email');
  });

  // methodology tooltip (same pattern as the royalty calculator)
  var ti = document.querySelector('[data-tinfo]');
  if (ti) {
    var tb = ti.querySelector('button');
    var set = function (o) { ti.classList.toggle('is-open', o); tb.setAttribute('aria-expanded', o ? 'true' : 'false'); };
    tb.addEventListener('click', function (e) { e.stopPropagation(); set(!ti.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!ti.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  window.DPPitch = { build: build, checks: checks };
  render();
})();
